<script>
  import t from "@/components/page/HomeView/data/text.json";

  export default {
    data() {
      return {
        t,
      };
    },
    props: ["page"],
  };
</script>

<template>
  <div class="more">
    <div class="content">
      <h3 class="more__name">Дэлгэрэнгүй мэдэх</h3>
      <div class="more__row">
        <router-link v-show="page !== item.link" :to="item.link" class="more__item" v-for="(item, id) in t.itemPages"
          :key="id">
          <div class="more__img">
            <div class="more__img-icon app-btn-circle">
              <img v-if="item.iconType === 'Судалгаа'" class="list-page__img-icon--icon1"
                src="@/assets/icons/ui/t_1.svg" alt="icon" />
              <img v-if="item.iconType === 'Видео'" class="list-page__img-icon--icon2" src="@/assets/icons/ui/t_2.svg"
                alt="icon" />
              <img v-if="item.iconType === 'Асуулт хариулт'" class="list-page__img-icon--icon3"
                src="@/assets/icons/ui/t_3.svg" alt="icon" />
              <img v-if="item.iconType === 'Өвчтөнд зориулсан мэдээлэл'" class="list-page__img-icon--icon4"
                src="@/assets/icons/ui/t_4.svg" alt="icon" />
            </div>

            <picture>
              <source :srcset="`${require('@/assets/img/ui/items/mob/' +
                item.img +
                '.webp')} 1x, ${require('@/assets/img/ui/items/mob/' +
                  item.img +
                  '@2x.webp')} 2x`" type="image/webp" />
              <img class="more__img-main" :src="require('@/assets/img/ui/items/mob/' + item.img + '@2x.png')
                " :srcset="`${require('@/assets/img/ui/items/mob/' +
                  item.img +
                  '.png')} 1x, ${require('@/assets/img/ui/items/mob/' +
                    item.img +
                    '@2x.png')} 2x`" :alt="`${item.name}`" />
            </picture>
          </div>

          <div class="more__col">
            <p class="more__type" v-html="item.iconType"></p>
            <h2 class="more__title" v-html="item.name"></h2>
          </div>
        </router-link>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
  .more {
    padding: 30px 60px 30px 60px;

    display: flex;
    flex-direction: column;
    align-items: center;

    @media screen and (max-width: 1024px) {
      padding: 32px 20px 32px 20px;
    }

    @media screen and (max-width: 600px) {
      padding: 48px 20px 20px 20px;
    }

    .content {
      max-width: 1320px;
      width: 100%;
    }

    &__name {
      color: var(--Text-White, #fff);
      font-family: "MetaPro", sans-serif;
      font-size: 24px;
      font-style: normal;
      font-weight: 700;
      line-height: 120%;
      margin-bottom: 24px;

      @media screen and (max-width: 1024px) {
        margin-bottom: 20px;
      }

      @media screen and (max-width: 600px) {
        font-size: 20px;
      }
    }

    &__row {
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      // grid-template-rows: repeat(2, 1fr);
      gap: 10px 20px;

      @media screen and (max-width: 700px) {
        gap: 10px;

        grid-template-columns: repeat(1, 1fr);
        // grid-template-rows: repeat(1, 1fr);
      }
    }

    &__item {
      display: grid;
      grid-template-columns: auto 1fr;
      position: relative;

      @media screen and (min-width: 1024px) {
        &:hover {
          .more__img-icon {
            cursor: pointer;
            user-select: none;

            &::before {
              background: radial-gradient(100% 100% at 50% 0%,
                  rgba(255, 255, 255, 1) 0%,
                  rgba(255, 255, 255, 0) 100%),
                linear-gradient(0deg, #22b28a 0%, #6fd691 100%);
            }

            &::after {
              background: linear-gradient(0deg, #01cb93 0%, #60fe94 100%);
            }
          }
        }
      }
    }

    &__img {
      width: 258px;
      position: relative;
      flex-shrink: 1;

      @media screen and (max-width: 1360px) {
        width: 200px;
      }

      @media screen and (max-width: 768px) {
        width: 156px;
      }

      &-main {
        width: 100%;
        height: auto;
        display: block;
      }

      &-icon {
        position: absolute;
        right: 0;
        top: 0;

        width: 22.5%;
        height: 29.01%;

        svg {
          position: relative;
          z-index: 2;

          height: auto;
          display: block;
        }
      }
    }

    &__col {
      margin-left: 24px;

      @media screen and (max-width: 1024px) {
        margin-left: 20px;
      }

      @media screen and (max-width: 600px) {
        margin-left: 10px;
      }
    }

    &__type {
      color: var(--9CFFAC, #9cffac);

      font-size: 18px;
      font-style: normal;
      font-weight: 400;
      line-height: 100%;
      letter-spacing: 0.72px;
      text-transform: uppercase;
      margin-bottom: 8px;

      @media screen and (max-width: 1024px) {
        font-size: 10px;
        line-height: 14px;
      }
    }

    &__title {
      color: var(--Text-White, #fff);
      font-family: "MetaPro", sans-serif;
      font-size: 28px;
      font-style: normal;
      font-weight: 500;
      line-height: 110%;
      text-transform: uppercase;

      @media screen and (max-width: 1360px) {
        font-size: 22px;
      }

      @media screen and (max-width: 1024px) {
        font-size: 16px;
      }
    }
  }
</style>
